import { render, staticRenderFns } from "./studentAvatar.vue?vue&type=template&id=1a4d64bb&scoped=true"
import script from "./studentAvatar.vue?vue&type=script&lang=js"
export * from "./studentAvatar.vue?vue&type=script&lang=js"
import style0 from "./studentAvatar.vue?vue&type=style&index=0&id=1a4d64bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d64bb",
  null
  
)

export default component.exports